import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Rezeptliste} from '../types/produktionsauftrag';
import {ApiResourceLocation, SOFTLINE_SERVICE_HTTP} from '@softline/core';
import {UpdateRezepturBeweParams} from '../types/update-rezeptur-bewe-params';
import {SOFTLINE_API_PRODUKTIONSAUFTRAG_UPDATE_REZEPT} from '../produktionsauftrag.api';

@Injectable()
export class RezepturBeweService {

  readonly httpService = inject(SOFTLINE_SERVICE_HTTP);

  update(params: UpdateRezepturBeweParams): Observable<Rezeptliste> {
    const location: ApiResourceLocation = {
      path: SOFTLINE_API_PRODUKTIONSAUFTRAG_UPDATE_REZEPT,
    }

    return this.httpService.update(location, params);
  }
}
